import { ApolloLink, Observable } from '@apollo/client';
import { print } from 'graphql';

const redact = (value: unknown) =>
  JSON.parse(
    JSON.stringify(value, (key, currentValue) =>
      /(password|token|authorization|cookie)/i.test(key) ? '***' : currentValue,
    ),
  );

export const gqlLoggerLink = new ApolloLink((operation, forward) => {
  if (!forward) {
    return null;
  }

  const startedAt = Date.now();
  const { operationName, variables } = operation;
  const context = operation.getContext?.() ?? {};
  const uri = context?.uri ?? '<?>';

  if (typeof window !== 'undefined') {
    console.groupCollapsed(`[GQL ➡] ${operationName || '(anonymous)'} → ${uri}`);
  } else {
    console.info(`[GQL ➡] ${operationName || '(anonymous)'} → ${uri}`);
  }

  console.info('[Vars]', redact(variables));
  console.info('[Query]', print(operation.query));

  return new Observable((observer) => {
    const subscription = forward(operation).subscribe({
      next: (response) => {
        const durationMs = Date.now() - startedAt;
        const dataKeys = Object.keys(response?.data || {});
        const hasErrors = Boolean(response?.errors?.length);

        console.info(
          `[GQL ⬅] ${operationName || '(anonymous)'} ${hasErrors ? 'ERROR' : 'OK'} in ${durationMs}ms dataKeys=`,
          dataKeys,
        );

        if (hasErrors) {
          for (const error of response.errors ?? []) {
            console.error('[GQL Error]', error);
          }
        }

        if (typeof window !== 'undefined') {
          console.groupEnd?.();
        }

        observer.next(response);
      },
      error: (error) => {
        if (typeof window !== 'undefined') {
          console.groupEnd?.();
        }

        observer.error(error);
      },
      complete: () => {
        if (typeof window !== 'undefined') {
          console.groupEnd?.();
        }

        observer.complete();
      },
    });

    return () => subscription.unsubscribe();
  });
});
